import { render, staticRenderFns } from "./DeleteCreationDialog.vue?vue&type=template&id=1b65bc10&scoped=true&"
import script from "./DeleteCreationDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteCreationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65bc10",
  null
  
)

export default component.exports